import fetchAPI from "./fetchAPI"

export async function requestGiftCount(id) {
  const { fetchGiftCount } = await fetchAPI(
    `query($id: String!) {
          fetchGiftCount(id: $id) {
              count,
              amount
            }
          }`,
    {
      variables: { id }
    }
  )

  return fetchGiftCount
}
